<template>
    <div class="">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-auto py-5">
                    <a href="/" title="Control Panel"><img class="logo" alt="control panel" :src="whitelabel.LOGO"/></a>
                </div>
            </div>
        </div>
        <div class="container position-relative">
            <div class="row justify-content-center">
                <div class="col-xs-12 col-md-12 col-lg-9 col-xl-7">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            whitelabel: "whitelabel"
        })
    },
    mounted() {
        this.$nextTick(() => {
            document.body.classList.add("body--guest");
        });
    }
};
</script>
<style scoped>
.logo {
    max-width: 400px;
}
</style>
